// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageCategoryList-containerWith-giYQK {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.ManageCategoryList-container-U5xZE {
    max-width: 100%;
}

/* Text - Start */

.ManageCategoryList-subText-KM_Y4 {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.ManageCategoryList-navigationLink-EC6uy a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.ManageCategoryList-navigationLink-EC6uy a:hover,
.ManageCategoryList-navigationLink-EC6uy a:focus,
.ManageCategoryList-navigationLink-EC6uy a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.ManageCategoryList-noPadding-UWqxW {
    padding: 0;
}

.ManageCategoryList-heading-FRHGm {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.ManageCategoryList-widthInner-B0mEh {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.ManageCategoryList-noMargin-Hc3Zw {
    margin: 0;
}

.ManageCategoryList-formControlInputTable-eve1w {
    border: none;
    width: 100px;
    height: auto;
}

.ManageCategoryList-backBtn-POKYh {
    margin-left: 15px;
    display: inline-block;
}

.ManageCategoryList-backBtn-POKYh:active,
.ManageCategoryList-backBtn-POKYh:hover,
.ManageCategoryList-backBtn-POKYh:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.ManageCategoryList-textAlignRight-MyV6a {
    text-align: right;
}

.ManageCategoryList-displayInlineBlock-lrz_j {
    display: inline-block;
}

.ManageCategoryList-displayBlock-DCAm2 {
    display: block;
}

.ManageCategoryList-countryCode-Jztfq {
    width: 15%;
    vertical-align: top;
}

.ManageCategoryList-vtrMiddle-n8QXB {
    vertical-align: middle;
}

/* commonCss */

.ManageCategoryList-editIcon-VFJ8N {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.ManageCategoryList-iconBtn-H8gdE,
.ManageCategoryList-iconBtn-H8gdE:hover,
.ManageCategoryList-iconBtn-H8gdE:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.ManageCategoryList-profileImg-u3yH9 {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.ManageCategoryList-profileImgSection-UdXhc {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.ManageCategoryList-profileImgWidth-nmgTt {
    margin: 0;
    max-width: 100% !important;
}

.ManageCategoryList-searchInput-JUrO2 {
    width: 100%;
    max-width: 320px;
}

.ManageCategoryList-backgroundImg-yEba_ {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.ManageCategoryList-exportDisplay-GG5yk {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.ManageCategoryList-exportTextSection-HT8Co {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ManageCategoryList-exportText-Zq_l_ {
    display: inline-block;
    padding-right: 5px;
}

.ManageCategoryList-exportTextContainer-FO9_C {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.ManageCategoryList-vtrTextBottom-xpAvC {
    vertical-align: text-bottom;
}

.ManageCategoryList-exportImg-WE_zy {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.ManageCategoryList-noLink-p60P1,
.ManageCategoryList-noLink-p60P1:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.ManageCategoryList-singleCard-Srxyi {
    width: 500px;
    margin: 0 auto;
}

.ManageCategoryList-defaultIcon-bSN8Q {
    background-size: 50px;
}

.ManageCategoryList-assignProviderSearchInput-nlKPu {
    width: 100%;
    max-width: 324px;
}

.ManageCategoryList-searchGroupContainer-CYIid {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .ManageCategoryList-searchGroupContainer-CYIid {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .ManageCategoryList-widthInner-B0mEh {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ManageCategoryList-aboutGrid-b9gFt img {
    position: relative;
    top: -25px !important;
  }

  .ManageCategoryList-responsiveView-LRZFW {
    width: 100% !important;
    max-width: 175px !important;
  }

  .ManageCategoryList-positionFive-xkpeq {
    top: 28% !important;
  }

  .ManageCategoryList-positionTwo-uxGh_ {
    top: 28% !important;
  }

  .ManageCategoryList-responsiveContentOne-u9ysP {
    top: -50px !important;
  }

  .ManageCategoryList-positionFour-huE4T {
    top: -50px !important;
  }

  .ManageCategoryList-totalCss-rbm0s {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .ManageCategoryList-navbar-expand-lg-RrH4q .ManageCategoryList-navbar-toggler-oDSIJ {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .ManageCategoryList-profileImgSection-UdXhc {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .ManageCategoryList-navigationLink-EC6uy a {
    color: var(--primary-foreground) !important;
  }

  .ManageCategoryList-widthInner-B0mEh {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .ManageCategoryList-responsiveContentOne-u9ysP {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .ManageCategoryList-positionTwo-uxGh_ {
    top: 24% !important;
    left: -5% !important;
  }

  .ManageCategoryList-positionThree-lkv3f {
    top: 70% !important;
    left: -5% !important;
  }

  .ManageCategoryList-positionFour-huE4T {
    top: -42px !important;
    right: -5% !important;
  }

  .ManageCategoryList-positionFive-xkpeq {
    top: 20% !important;
    right: -5% !important;
  }

  .ManageCategoryList-positionSix-AEoS9 {
    top: 70% !important;
    right: -5% !important;
  }

  .ManageCategoryList-responsiveView-LRZFW {
    width: 100% !important;
    max-width: 115px !important;
  }

  .ManageCategoryList-aboutGrid-b9gFt img {
    top: -1px !important;
  }

  .ManageCategoryList-contentOne-sdzOE h1 {
    font-size: 16px !important;
  }

  .ManageCategoryList-contentOne-sdzOE p {
    font-size: 12px !important;
  }


  .ManageCategoryList-totalCss-rbm0s {
    width: 100% !important;
  }

  .ManageCategoryList-padding-Pc7uN {
    padding: 0px 0 0 60px !important;
  }

  .ManageCategoryList-singleCard-Srxyi {
    width: 100% !important;
  }

  .ManageCategoryList-navigationLink-EC6uy a:hover,
  .ManageCategoryList-navigationLink-EC6uy a:focus,
  .ManageCategoryList-navigationLink-EC6uy a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .ManageCategoryList-navbar-collapse-oat35.ManageCategoryList-show-LU42k {
    right: 0% !important;
    top: 0 !important;
  }

  .ManageCategoryList-navbar-collapse-oat35 {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .ManageCategoryList-content-Brxqv {
    float: none;
  }

  .ManageCategoryList-mr-auto-i6b9U.ManageCategoryList-navbar-nav-ETPEg {
    padding-bottom: 80px !important;
  }

  .ManageCategoryList-navigationLink-EC6uy a {
    color: var(--primary-foreground) !important;
  }

  .ManageCategoryList-footer-I7i3n {
    padding: 35px 0 0 15px;
  }

  .ManageCategoryList-widthInner-B0mEh {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .ManageCategoryList-responsiveNoPadding-LX2SD {
    padding: 0px !important;
  }

  .ManageCategoryList-contentOne-sdzOE {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .ManageCategoryList-aboutContainer-DBwyy {
    padding: 30px 0 30px !important;
  }

  .ManageCategoryList-noPosition-LYxf5 {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .ManageCategoryList-mobimleImg-KLPxn {
    display: none !important;
  }

  .ManageCategoryList-totalCss-rbm0s {
    width: 100% !important;
  }

  .ManageCategoryList-imgWidth-Yk0OV {
    padding: 18px !important;
  }

  .ManageCategoryList-searchInput-JUrO2,
  .ManageCategoryList-assignProviderSearchInput-nlKPu {
    max-width: 100% !important;
  }

  .ManageCategoryList-exportText-Zq_l_ {
    display: inline-block;
  }

  .ManageCategoryList-gridSystem-xDWMn {
    grid-template-columns: auto !important;
  }

  .ManageCategoryList-padding-Pc7uN {
    padding: 52px 0 0 0 !important;
  }

  .ManageCategoryList-heading-FRHGm {
    padding: 30px 0 24px !important;
  }

  .ManageCategoryList-singleCard-Srxyi {
    width: 100% !important;
  }

  .ManageCategoryList-displayGrid-u2OQy {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .ManageCategoryList-boxInner-ZV810 {
    padding: 35px 0 !important;
  }

  .ManageCategoryList-navigationLink-EC6uy a:hover,
  .ManageCategoryList-navigationLink-EC6uy a:focus,
  .ManageCategoryList-navigationLink-EC6uy a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .ManageCategoryList-whiteDropdown-COINE select {
    width: 120px !important;
  }
}

.ManageCategoryList-manageServiceCardContainer-VOM7J {
    display: grid;
    grid-template-columns: repeat(7, calc(14.28571% - 20.57143px));
    gap: 24px;
    margin-top: 32px;
}

.ManageCategoryList-manageServiceCard-l40W_,
.ManageCategoryList-manageServiceCard-l40W_:hover,
.ManageCategoryList-manageServiceCard-l40W_:focus {
    color: var(--primary-foreground);
    text-decoration: none;
}

.ManageCategoryList-manageServiceCardNoResultContainer-XPsLB {
    margin-top: 32px;
    min-height: 492px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 12px;
    grid-gap: 12px;
}

.ManageCategoryList-manageServiceCardNoResultImgBox-zvGSb {
    width: 188px;
    height: 178px;
    position: relative;
}

.ManageCategoryList-manageServiceCardNoResultImg-CWXQ3 {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.ManageCategoryList-manageServiceCardNoResultText-cn4nh {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: var(--secondary-foreground);
    text-align: center;
}

@media (max-width: 1399px) and (min-width: 1300px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: repeat(6, calc(16.66667% - 20px));
    }
}

@media (max-width: 1299px) and (min-width: 1200px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: repeat(5, calc(20% - 19.2px));
    }
}

@media (max-width: 1199px) and (min-width: 768px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: repeat(4, calc(25% - 18px));
    }
}

@media (max-width: 767px) and (min-width: 576px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: repeat(3, calc(33.33333% - 16px));
    }
}

@media (max-width: 575px) {
    .ManageCategoryList-manageServiceCardNoResultContainer-XPsLB {
        min-height: 350px;
    }
}

@media (max-width: 575px) and (min-width: 361px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: repeat(2, calc(50% - 12px));
    }
}

@media (max-width: 360px) {
    .ManageCategoryList-manageServiceCardContainer-VOM7J {
        grid-template-columns: 100%
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/ManageCategory/ManageCategoryList/ManageCategoryList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;IACI,aAAa;IACb,8DAA+D;IAC/D,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;IAGI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI;QACI,wDAA+D;IACnE;AACJ;;AAEA;IACI;QACI,oDAA+D;IACnE;AACJ;;AAEA;IACI;QACI,kDAA+D;IACnE;AACJ;;AAGA;IACI;QACI,wDAA+D;IACnE;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kDAAyD;IAC7D;AACJ;;AAEA;IACI;QACI;IACJ;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.manageServiceCardContainer {\n    display: grid;\n    grid-template-columns: repeat(7, calc((100% - (24px * 6)) / 7));\n    gap: 24px;\n    margin-top: 32px;\n}\n\n.manageServiceCard,\n.manageServiceCard:hover,\n.manageServiceCard:focus {\n    color: var(--primary-foreground);\n    text-decoration: none;\n}\n\n.manageServiceCardNoResultContainer {\n    margin-top: 32px;\n    min-height: 492px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 12px;\n    grid-gap: 12px;\n}\n\n.manageServiceCardNoResultImgBox {\n    width: 188px;\n    height: 178px;\n    position: relative;\n}\n\n.manageServiceCardNoResultImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.manageServiceCardNoResultText {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    color: var(--secondary-foreground);\n    text-align: center;\n}\n\n@media (max-width: 1399px) and (min-width: 1300px) {\n    .manageServiceCardContainer {\n        grid-template-columns: repeat(6, calc((100% - (24px * 5)) / 6));\n    }\n}\n\n@media (max-width: 1299px) and (min-width: 1200px) {\n    .manageServiceCardContainer {\n        grid-template-columns: repeat(5, calc((100% - (24px * 4)) / 5));\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n    .manageServiceCardContainer {\n        grid-template-columns: repeat(4, calc((100% - (24px * 3)) / 4));\n    }\n}\n\n\n@media (max-width: 767px) and (min-width: 576px) {\n    .manageServiceCardContainer {\n        grid-template-columns: repeat(3, calc((100% - (24px * 2)) / 3));\n    }\n}\n\n@media (max-width: 575px) {\n    .manageServiceCardNoResultContainer {\n        min-height: 350px;\n    }\n}\n\n@media (max-width: 575px) and (min-width: 361px) {\n    .manageServiceCardContainer {\n        grid-template-columns: repeat(2, calc((100% - 24px) / 2));\n    }\n}\n\n@media (max-width: 360px) {\n    .manageServiceCardContainer {\n        grid-template-columns: 100%\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `ManageCategoryList-containerWith-giYQK`,
	"container": `ManageCategoryList-container-U5xZE`,
	"subText": `ManageCategoryList-subText-KM_Y4`,
	"navigationLink": `ManageCategoryList-navigationLink-EC6uy`,
	"noPadding": `ManageCategoryList-noPadding-UWqxW`,
	"heading": `ManageCategoryList-heading-FRHGm`,
	"widthInner": `ManageCategoryList-widthInner-B0mEh`,
	"noMargin": `ManageCategoryList-noMargin-Hc3Zw`,
	"formControlInputTable": `ManageCategoryList-formControlInputTable-eve1w`,
	"backBtn": `ManageCategoryList-backBtn-POKYh`,
	"textAlignRight": `ManageCategoryList-textAlignRight-MyV6a`,
	"displayInlineBlock": `ManageCategoryList-displayInlineBlock-lrz_j`,
	"displayBlock": `ManageCategoryList-displayBlock-DCAm2`,
	"countryCode": `ManageCategoryList-countryCode-Jztfq`,
	"vtrMiddle": `ManageCategoryList-vtrMiddle-n8QXB`,
	"editIcon": `ManageCategoryList-editIcon-VFJ8N`,
	"iconBtn": `ManageCategoryList-iconBtn-H8gdE`,
	"profileImg": `ManageCategoryList-profileImg-u3yH9`,
	"profileImgSection": `ManageCategoryList-profileImgSection-UdXhc`,
	"profileImgWidth": `ManageCategoryList-profileImgWidth-nmgTt`,
	"searchInput": `ManageCategoryList-searchInput-JUrO2`,
	"backgroundImg": `ManageCategoryList-backgroundImg-yEba_`,
	"exportDisplay": `ManageCategoryList-exportDisplay-GG5yk`,
	"exportTextSection": `ManageCategoryList-exportTextSection-HT8Co`,
	"exportText": `ManageCategoryList-exportText-Zq_l_`,
	"exportTextContainer": `ManageCategoryList-exportTextContainer-FO9_C`,
	"vtrTextBottom": `ManageCategoryList-vtrTextBottom-xpAvC`,
	"exportImg": `ManageCategoryList-exportImg-WE_zy`,
	"noLink": `ManageCategoryList-noLink-p60P1`,
	"singleCard": `ManageCategoryList-singleCard-Srxyi`,
	"defaultIcon": `ManageCategoryList-defaultIcon-bSN8Q`,
	"assignProviderSearchInput": `ManageCategoryList-assignProviderSearchInput-nlKPu`,
	"searchGroupContainer": `ManageCategoryList-searchGroupContainer-CYIid`,
	"aboutGrid": `ManageCategoryList-aboutGrid-b9gFt`,
	"responsiveView": `ManageCategoryList-responsiveView-LRZFW`,
	"positionFive": `ManageCategoryList-positionFive-xkpeq`,
	"positionTwo": `ManageCategoryList-positionTwo-uxGh_`,
	"responsiveContentOne": `ManageCategoryList-responsiveContentOne-u9ysP`,
	"positionFour": `ManageCategoryList-positionFour-huE4T`,
	"totalCss": `ManageCategoryList-totalCss-rbm0s`,
	"navbar-expand-lg": `ManageCategoryList-navbar-expand-lg-RrH4q`,
	"navbar-toggler": `ManageCategoryList-navbar-toggler-oDSIJ`,
	"positionThree": `ManageCategoryList-positionThree-lkv3f`,
	"positionSix": `ManageCategoryList-positionSix-AEoS9`,
	"contentOne": `ManageCategoryList-contentOne-sdzOE`,
	"padding": `ManageCategoryList-padding-Pc7uN`,
	"navbar-collapse": `ManageCategoryList-navbar-collapse-oat35`,
	"show": `ManageCategoryList-show-LU42k`,
	"content": `ManageCategoryList-content-Brxqv`,
	"mr-auto": `ManageCategoryList-mr-auto-i6b9U`,
	"navbar-nav": `ManageCategoryList-navbar-nav-ETPEg`,
	"footer": `ManageCategoryList-footer-I7i3n`,
	"responsiveNoPadding": `ManageCategoryList-responsiveNoPadding-LX2SD`,
	"aboutContainer": `ManageCategoryList-aboutContainer-DBwyy`,
	"noPosition": `ManageCategoryList-noPosition-LYxf5`,
	"mobimleImg": `ManageCategoryList-mobimleImg-KLPxn`,
	"imgWidth": `ManageCategoryList-imgWidth-Yk0OV`,
	"gridSystem": `ManageCategoryList-gridSystem-xDWMn`,
	"displayGrid": `ManageCategoryList-displayGrid-u2OQy`,
	"boxInner": `ManageCategoryList-boxInner-ZV810`,
	"whiteDropdown": `ManageCategoryList-whiteDropdown-COINE`,
	"manageServiceCardContainer": `ManageCategoryList-manageServiceCardContainer-VOM7J`,
	"manageServiceCard": `ManageCategoryList-manageServiceCard-l40W_`,
	"manageServiceCardNoResultContainer": `ManageCategoryList-manageServiceCardNoResultContainer-XPsLB`,
	"manageServiceCardNoResultImgBox": `ManageCategoryList-manageServiceCardNoResultImgBox-zvGSb`,
	"manageServiceCardNoResultImg": `ManageCategoryList-manageServiceCardNoResultImg-CWXQ3`,
	"manageServiceCardNoResultText": `ManageCategoryList-manageServiceCardNoResultText-cn4nh`
};
module.exports = ___CSS_LOADER_EXPORT___;
